import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Servico } from '../../components'
import * as servicoActionCreators from '../../redux/modules/servico'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'


class ServicoContainer extends Component {

  static propTypes = {
    history: PropTypes.object,
    multipleServico: PropTypes.object,
    fetchMultipleServico: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    destroyServico: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleServico()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/servicos/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/servicos/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyServico(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('servico', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('servico', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleServico.toList().toJSON(),
      'servico',
      ['id', 'nome', 'descricao'],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <Servico
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleServico={this.props.multipleServico}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({ servico, status, sort, filter }) {
  const sortColumn = sort.getIn(['servico', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['servico', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['servico', 'filterText']) || ''

  let map = filterMap(servico, ['nome', 'descricao'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleServico: map,
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['servico', 'error']),
    isLoading: status.getIn(['servico', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...flashMessageAcionCreators,
    ...servicoActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicoContainer)
